module.exports = __webpack_public_path__ + "img/crea-compte.a8f9d2b9.png";